import {
  Box,
  Button,
  IconButton,
  Paper,
  Snackbar,
  TextField,
  zApikey,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { getOpenSnakSuccessData } from "../../../../config/otherConstant";
import { EXTENSION_IDENTIFIER } from "../../../../config/serviceConstant";

function DelugeFunction(props) {
  const { children, value, index, connectionDetails, currentUser, orgId,zApiKey, setSnack, ...other } = props;

  const data = {
    textToCopy: `
  // In Deluge
	email_of_conn_user = zoho.loginuserid; // if want to get Login User Access Token
	// email_of_conn_user = record_resp.get("Owner").get("email"); // if want to get Owner Access Token
	// email_of_conn_user = "email@yourdomain.com"; // If want to get Specific user's Access Token
	config = {
		  "connname": "${connectionDetails?.service?.serviceConnection?.split("__")?.[1]}__${connectionDetails?.data?.connApiName}",
		  "email": email_of_conn_user,
		  "orgid": "${orgId}"
	};
	accesstoken_resp = invokeurl
	[
		url: "https://www.zohoapis.com/crm/v2/functions/easyauthenticator__getaccesstokenforrestapi/actions/execute?auth_type=apikey&zapikey=${zApiKey}"
		type: POST
		parameters: config.toString()
	];
	access_token = ifnull( ifnull(accesstoken_resp.get("details"), Map()).get("output"), "");
	info access_token; 
 
headers = {
  "Authorization": "Bearer " + access_token, 
  "your additional headers": "your headers value"
};
response = invokeurl
  [
    url: <expression>
    type: <request_type>
    parameters: <expression>
    headers: headers
  ];
    `,
  };

  // Function to handle copy
  const handleCopy = () => {
    navigator.clipboard.writeText(data.textToCopy).then(() => {
      setSnack(getOpenSnakSuccessData("Code copied successfully"));
    });
  };

  if (value != index) {
    return <></>;
  }

  return (
    <Box sx={{ position: "relative", width: "100vh" }}>
      <Paper elevation={3} sx={{ padding: "16px", backgroundColor: "#f0f4fa" }}>
        <Typography
          variant="body1"
          sx={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}
        >
          {data?.textToCopy}
        </Typography>
        <IconButton
          onClick={handleCopy}
          sx={{ position: "absolute", top: "10px", right: "10px" }}
          aria-label="copy to clipboard"
        >
          <ContentCopyIcon />
        </IconButton>
      </Paper>
    </Box>
  );
}

export default DelugeFunction;
